export const normalizeYyyyMmDd = (value: string): string => {
  return String(value || '').slice(0, 10);
};

export const getLocalYyyyMmDd = (date: Date = new Date()): string => {
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 10);
};

export const addDaysYyyyMmDd = (yyyyMmDd: string, days: number): string => {
  const base = normalizeYyyyMmDd(yyyyMmDd);
  const d = new Date(`${base}T00:00:00`);
  d.setDate(d.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const formatHumanFromYyyyMmDd = (yyyyMmDd: string): string => {
  const base = normalizeYyyyMmDd(yyyyMmDd);
  if (!base) return '';
  const d = new Date(`${base}T00:00:00`);
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
